import type { MemberProfile } from "../shared/types";

export function memberProfileName(profile: MemberProfile): string {
  return profile.name?.trim() || "미등록";
}

export function memberProfileBirthDate(profile: MemberProfile): string {
  return profile.birthDate && /^\d{4}-\d{2}-\d{2}$/.test(profile.birthDate) ? profile.birthDate : "미등록";
}

export function MemberProfilePhone({ profile }: { readonly profile: MemberProfile }) {
  const labels: Record<string, string> = { SKT: "SKT", KT: "KT", KTF: "KT", LGU: "LGU+", LGT: "LGU+", "LGU+": "LGU+" };
  const network = profile.mvnoNetwork && labels[profile.mvnoNetwork];
  const telecom = profile.telecomCode === "MVNO" ? network ? `${network}알뜰폰` : "알뜰폰(통신망 미등록)"
    : profile.telecomCode ? labels[profile.telecomCode] ?? "통신사 확인 필요" : "미등록";
  const number = profile.phoneNumber?.trim();
  const phone = number ? number.replace(/^(\d{3})(\d{3,4})(\d{4})$/, "$1-$2-$3") : "미등록";
  return <span className="member-profile-phone"><span>{telecom}</span>{" "}<span className="member-profile-phone__number">{phone}</span></span>;
}
